import { useContext } from 'react';
import pluralize from 'pluralize';

import { media } from 'context';
import { Layout, ProductImg, Text } from 'ds';
import { getHighlightedPartsOfText } from 'ds/utils';
import { formatUsd } from 'helpers';
import { ConsumablesProduct } from 'shared';

interface ConsumablesProductResultProps {
  product: ConsumablesProduct;
  query: string | undefined;
}
const ConsumablesProductResult = ({
  product: { detail, brand, amount_cents, unit_type, units_per_package, package_type, image_key },
  query
}: ConsumablesProductResultProps) => {
  const { isMobile } = useContext(media);
  const getHighlightedText = ({ text, query }: { text: string; query?: string }) => {
    if (!query) return text;

    const parts = getHighlightedPartsOfText({ text, query });

    return (
      <span>
        {parts.map((part, index) =>
          part.toLowerCase() === query.toLowerCase() ? <b key={part + index}>{part}</b> : part
        )}
      </span>
    );
  };

  return (
    <Layout
      {...(isMobile
        ? { height: '100%', paddingY: 12, align: 'center', paddingX: 24 }
        : { height: 60, paddingY: 8, paddingX: 16 })}
      width="100%"
      flex
      direction="row"
      gap={12}
    >
      <ProductImg srcKey={image_key} style={{ width: 44, height: 44 }} size="sm" alt={detail} />
      <Layout flex direction="column" flexGrow={1} gap={isMobile ? 2 : 4}>
        <Layout
          direction="row"
          justify="space-between"
          {...(isMobile ? { height: '100%', gap: 12, align: 'center' } : { height: 24 })}
        >
          <Text {...(isMobile ? { size: 'body-md' } : { maxLines: 1, size: 'body-sm' })}>
            {getHighlightedText({
              text: `${brand} ${detail}`,
              query
            })}
          </Text>
          <Text size="body-sm" color="gray-700" wrap={false}>
            {formatUsd(amount_cents / 100)} ea.
          </Text>
        </Layout>
        <Layout>
          <Text size={isMobile ? 'body-sm' : 'body-xs'} color="gray-400">
            {pluralize(unit_type, 2)} ({units_per_package}/{package_type})
          </Text>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ConsumablesProductResult;
